import { createElement, memo, useCallback, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import './index.scss';
import { ActivityStatus } from '../../types/shared';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import VapView from '../vap-view';
import { ASSIST_MODAL_VAP } from '../../const';
import Animated from '@max/mbc-animated';
import AnimateView from '@max/mbc-animate-view';
import { getFullScreenSize } from '../../utils/layout';
const { fullScreenWidth, fullScreenHeight } = getFullScreenSize();
const CONTENT_APPEAR_DELAY = 400;
function GuestAssistModal(props) {
    const { visible, activityStatus, onClose, onOpened, onClickJoin } = props;
    const buttonText = activityStatus === ActivityStatus.ON_PROGRESS ? '知道啦' : '探索城市';
    const isVideoEndRef = useRef(false);
    // 动画状态
    const contentOpacity = useRef(new Animated.Value(0));
    const contentScale = useRef(new Animated.Value(0.5));
    const closeBtnOpacity = useRef(new Animated.Value(0));
    const playContentAnimation = useCallback(() => {
        contentOpacity.current.setValue(0);
        contentScale.current.setValue(0.5);
        closeBtnOpacity.current.setValue(0);
        const playContentTimer = setTimeout(() => {
            Animated.parallel([Animated.timing(contentOpacity.current, {
                    toValue: 1,
                    duration: 200,
                    useNativeDriver: true
                }), Animated.sequence([Animated.timing(contentScale.current, {
                        toValue: 1.1,
                        duration: 200,
                        useNativeDriver: true
                    }), Animated.timing(contentScale.current, {
                        toValue: 1,
                        duration: 120,
                        useNativeDriver: true
                    })]), Animated.timing(closeBtnOpacity.current, {
                    toValue: 1,
                    duration: 200,
                    useNativeDriver: true
                })]).start();
            clearTimeout(playContentTimer);
        }, CONTENT_APPEAR_DELAY);
    }, []);
    return <TopView>
      <ModalBaseContainer visible={visible} type="fade" onMaskPress={onClose} onOpened={onOpened} contentStyle={{
        height: fullScreenHeight,
        width: fullScreenWidth,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }}>
        <View className="guest-assist-modal__vap-wrapper" style={{
        height: fullScreenHeight
    }}>
          <VapView {...ASSIST_MODAL_VAP} autoPlay loop={false} keepLastFrame isFullScreen widthHeightRatio={750 / 1624} height={fullScreenHeight} width={fullScreenWidth} onStart={() => {
        playContentAnimation();
    }} onVideoEnd={() => {
        isVideoEndRef.current = true;
    }}/>
        </View>
        <View className="guest-assist-modal__content-layer">
          <AnimateView animateStyles={{
        opacity: contentOpacity.current,
        transform: [{
                scale: contentScale.current
            }]
    }}>
            <Image className="guest-assist-modal__header-img" source={{
        uri: 'https://p0.meituan.net/ingee/0cc9270b401d38dbcc6c763971b9f86119082.png'
    }}/>
            <View className="guest-assist-modal__content-wrapper">
              <Image className="guest-assist-modal__icon" source={{
        uri: 'https://p0.meituan.net/ingee/c39737d2e92ab0ee90fffea71bf7d436135841.png'
    }}/>
              <Text className="guest-assist-modal__title">成功帮好友赢得积分</Text>
              <Text className="guest-assist-modal__desc">你也来探索城市，赢免单卡</Text>
              <Button className="guest-assist-modal__button" onPress={() => {
        if (activityStatus === ActivityStatus.ON_PROGRESS) {
            onClickJoin();
        }
        onClose();
    }}>
                <Text className="guest-assist-modal__button-text">{buttonText}</Text>
              </Button>
            </View>
          </AnimateView>
          <AnimateView style={{
        width: '750rpx'
    }} animateStyles={{
        opacity: closeBtnOpacity.current
    }}>
            <Button className="modal-close-button" onPress={() => {
        onClose();
    }}>
              <Image className="modal-close-button-img" source={{
        uri: 'https://p0.meituan.net/ingee/dacb6cc62b5d35e0e749fc7a73bbe7821798.png'
    }}/>
            </Button>
          </AnimateView>
        </View>
      </ModalBaseContainer>
    </TopView>;
}
export default memo(GuestAssistModal);
